// extracted by mini-css-extract-plugin
export default {"cls1":"useAttachment-cls1_W4Z","cls2":"useAttachment-cls2__ZB useAttachment-cls1_W4Z"};